import React, { useEffect, useState } from 'react';
import { Button } from '../common/Button';
import * as api from '../../api/user-app-api'; // ✅ will include new APIs

export const HelpScreen = ({ setView, params }) => {
    const [faqs, setFaqs] = useState([]);
    const [reviews, setReviews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // ✅ Fetch FAQs & Reviews from backend
    const fetchHelpData = async () => {
        try {
            const [faqRes, reviewRes] = await Promise.all([
                api.fetchFaqs(),
                api.fetchCustomerReviews(),
            ]);

            if (Array.isArray(faqRes.data)) setFaqs(faqRes.data);
            else if (faqRes.data?.faqs) setFaqs(faqRes.data.faqs);

            if (Array.isArray(reviewRes.data)) setReviews(reviewRes.data);
            else if (reviewRes.data?.reviews) setReviews(reviewRes.data.reviews);
        } catch (err) {
            console.error("Error loading help data:", err);
            setError("Failed to load help content. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchHelpData();
    }, []);

    const handleContact = () => {
        if (typeof setView !== 'function') {
            console.warn('setView is not provided to HelpScreen');
            return;
        }

        if (params?.orderId) {
            setView('contact', { orderId: params.orderId });
        } else {
            setView('contact');
        }
    };


    if (loading) return <div className="p-6 text-center">Loading Help Content...</div>;
    if (error) return <div className="p-6 text-center text-red-600">{error}</div>;

    return (
        <div className="p-4 pt-0 mb-16">
            {/* Order Context */}
            {params?.orderId && (
                <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 mb-6">
                    <p className="font-medium text-gray-800">
                        Need help with Order #{params.orderId.slice(-6)}?
                    </p>
                    <Button onClick={handleContact} className="mt-3 w-full">
                        Contact Support
                    </Button>
                </div>
            )}

            {/* FAQs */}
            <div className="mb-8">
                <h3 className="font-semibold text-gray-800 mb-4">Frequently Asked Questions</h3>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className="bg-white p-4 rounded-xl shadow-sm border border-gray-100"
                        >
                            <p className="font-medium text-gray-800 mb-2">{faq.question}</p>
                            <p className="text-sm text-gray-600">{faq.answer}</p>
                        </div>
                    ))}
                    {faqs.length === 0 && (
                        <p className="text-gray-500 text-sm text-center">No FAQs found.</p>
                    )}
                </div>
            </div>

            {/* Customer Reviews */}
            <div className="mb-8">
                <h3 className="font-semibold text-gray-800 mb-4">What Our Customers Say</h3>
                <div className="space-y-4">
                    {reviews.map((review, index) => (
                        <div
                            key={index}
                            className="bg-white p-4 rounded-xl shadow-sm border border-gray-100"
                        >
                            <div className="flex items-center mb-2">
                                <div className="w-10 h-10 rounded-full bg-[#01a499]/10 flex items-center justify-center text-[#01a499] font-bold">
                                    {review.customer_name?.charAt(0).toUpperCase() || '?'}
                                </div>
                                <div className="ml-3">
                                    <p className="font-medium text-gray-800">
                                        {review.customer_name}
                                    </p>
                                    <div className="flex text-yellow-400">
                                        {'★'.repeat(review.rating || 0)}
                                        {'☆'.repeat(5 - (review.rating || 0))}
                                    </div>
                                </div>
                            </div>
                            <p className="text-sm text-gray-600">{review.comment}</p>
                        </div>
                    ))}
                    {reviews.length === 0 && (
                        <p className="text-gray-500 text-sm text-center">No reviews available.</p>
                    )}
                </div>
                <div style={{height:100}}/>
            </div>

            {/* Contact Button */}
            {!params?.orderId && (
                <div className="fixed bottom-16 left-0 right-0 p-4 bg-white border-t pb-7 space-y-2">
                    <Button onClick={() => setView('contact')}>Contact Support</Button>
                    <Button onClick={() => setView('privacyPolicy')} className="!bg-gray-600">
                        Privacy Policy
                    </Button>
                </div>
            )}
        </div>
    );
};
